<template>
  <div>
    <b-card class="bg-white rounded-xl">
      <b-button
        type="button"
        class="back-btn flex items-center ml-3 mb-4"
        @click="showCorporatebooking"
      >
        <feather-icon
          icon="ChevronLeftIcon"
          @click="showCorporatebooking"
          svgClasses=""
        />
        Back
      </b-button>

      <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
          <div class="flex w-full justify-evenly">
            <div class="w-48">
              <base-input
                v-model="form.name"
                name="Company Name"
                :rules="{ required: true, regex: '^[a-zA-Z0-9 ]+$' }"
              >
                <b-form-group
                  id="input-group-2"
                  label="Company Name:"
                  label-for="input-2"
                  class="mb-1"
                >
                  <b-form-input
                    id="input-2"
                    v-model="form.name"
                    placeholder="Enter Company Name"
                    name="Title"
                  >
                  </b-form-input> </b-form-group
              ></base-input>
            </div>

            <div class="w-48">
              <!-- <b-form @submit="onSubmit" @reset="onReset" v-if="show"> -->
              <base-input
                v-model="form.email"
                name="Email"
                :rules="{ required: true, email: true }"
              >
                <b-form-group
                  id="input-group-1"
                  label="Email :"
                  label-for="input-1"
                  class="mb-1"
                >
                  <b-form-input
                    id="input-1"
                    v-model="form.email"
                    type="email"
                    placeholder="Enter email"
                  >
                  </b-form-input>
                </b-form-group>
              </base-input>
              <!-- </b-form> -->
            </div>
          </div>

          <div class="flex justify-evenly w-full">
            <div class="w-48">
              <base-input
                v-model="form.mobileno"
                name="Mobile Number"
                :rules="{ required: true, numeric: true, min: 10, max: 10 }"
              >
                <b-form-group
                  id="input-group-2"
                  label="Enter Phone Number"
                  label-for="input-2"
                  class="mb-1"
                >
                  <b-form-input
                    v-model="form.mobileno"
                    placeholder="Enter your number"
                  ></b-form-input>
                </b-form-group>
              </base-input>
            </div>
            <div class="w-48">
              <base-input
                v-model="form.licenceno"
                name="No. of License"
                :rules="{ required: true, numeric: true }"
              >
                <b-form-group
                  id="input-group-2"
                  label="No. of License"
                  label-for="input-2"
                  class="mb-1"
                >
                  <b-form-input
                    v-model="form.licenceno"
                    placeholder="Enter No. of License"
                  ></b-form-input>
                </b-form-group>
              </base-input>
            </div>
          </div>

          <div class="flex justify-evenly w-full">
            <div class="w-48">
              <base-input
                v-model="time1"
                name="Start Date"
                :rules="{ required: true }"
              >
                <b-form-group label="Start Date:" class="mb-1">
                  <date-picker
                    v-model="time1"
                    class="w-full"
                    valueType="date"
                    :disabled-date="startDisableDate"
                    format="DD-MM-YYYY"
                    placeholder="Select Start Date"
                  ></date-picker>
                </b-form-group>
              </base-input>
            </div>

            <div class="w-48 cust-label-space">
              <base-input
                v-model="time2"
                name="End Date"
                :rules="{ required: true }"
              >
                <b-form-group
                  id="input-group-2"
                  label="End Date:"
                  label-for="input-2"
                  class="mb-0"
                >
                  <date-picker
                    v-model="time2"
                    class="w-full"
                    :disabled-date="endDisableDate"
                    valueType="date"
                    format="DD-MM-YYYY"
                    placeholder="Select End Date"
                  ></date-picker>
                </b-form-group>
              </base-input>
            </div>
          </div>

          <!-- 
      <label for="datepicker-valid">start date</label>
      <b-form-datepicker
        id="datepicker-valid"
        :state="true"
      ></b-form-datepicker> -->

          <!-- <div class="w-48 ml-3.5">
        <b-form-group
          id="input-group-3"
          label="status:"
          label-for="input-3"
          description="Required"
        >
          <b-form-select
            id="input-3"
            aria-placeholder="type"
            v-model="form.status"
            :options="status"
            required
          >
          </b-form-select>
        </b-form-group>
      </div> -->

          <b-button type="submit" variant="primary" class="mx-auto flex my-8"
            >Submit</b-button
          >
        </b-form>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { mapState } from "vuex";
import _ from "lodash";
import emailMixin from "@/mixins/email";
import { errorMonitor } from "stream";
export default {
  mixins: [emailMixin],
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const minDate = new Date(today);
    minDate.setMonth(minDate.getMonth() - 1);
    minDate.setDate(15);
    const maxDate = new Date(today);
    maxDate.setMonth(maxDate.getMonth() + 1);
    maxDate.setDate(15);
    return {
      form: {
        // name: "test",
        // email: "konakah453@quipas.com",
        // value: "",
        // status: "type",
        // mobileno: "9892169578",
        // licenceno: "10",
        name: "",
        email: "",
        value: "",
        status: "type",
        mobileno: "",
        licenceno: "",
      },
      time1: null,
      time2: null,
      status: ["Active ", "Pending", "On Hold", "Cancel"],
      flatdate: null,
      show: true,
      min: minDate,
      max: maxDate,
    };
  },

  methods: {
    endDisableDate(date) {
      if (this.time1) {
        let newDate = new Date(date);
        return newDate <= new Date(this.time1);
      }
    },
    startDisableDate(date) {
      if (this.time2) {
        let newDate = new Date(date);
        return newDate >= new Date(this.time2);
      }
    },
    async onSubmit(event) {
      let payload = {
        companyName: this.form.name,
        email: this.form.email,
        mobileno: this.form.mobileno,
        licence: this.form.licenceno,
        availableLicence: this.form.licenceno,
        startDate: this.time1,
        endDate: this.time2,
        // status: this.form.status,
      };
      let loader = this.$loading();
      try {
        const data = await this.$store.dispatch("corporate/create", payload);
        if (data.code === 200) {
          // console.log(data);
          this.$router.push({ name: "admin-corporateBooking" });
          this.$swal.fire({
            title: "Congratulations!",
            text: "Your booking has been successfully added!",
            icon: "success",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });

          const bcc = ["ruchita.sinh@aiab.in"];
          // const bcc = ["maneesh.mashelkar@aiab.in"];
          const to = [this.form.email];
          const subject =
            "Hi " +
            this.form.name +
            " Welcome to Caregiver, Please Find Login Credentials!!";
          const body = `
            <html>
        <body >
        <table width="100%" border="0" align="center" cellpadding="0" cellspacing="0" style="background-color:#dcfbf8">

<!-- START HEADER/BANNER -->

		<tbody><tr>
			<td align="center">
				<table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0">
					<tbody><tr>
						<td align="center" valign="top" background="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/brandimage.jpg" bgcolor="#66809b" style="   background-repeat: no-repeat; background-position:top;height="400""="">
							<table class="col-600" width="600" height="250" border="0" align="center" cellpadding="0" cellspacing="0">

								<tbody><tr>
									<td height="40"></td>
								</tr>

								<tr>
									<td height="50"></td>
								</tr>
							</tbody></table>
						</td>
					</tr>
				</tbody></table>
			</td>
		</tr>


<!-- END HEADER/BANNER -->


<!-- START 3 BOX SHOWCASE -->

		<tr>
			<td align="center">
				<table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0" style="background-color:#FBF6F6;margin-left:20px; margin-right:20px; ">
					<tbody><tr>
						<td height="35"></td>
					</tr>

            		<tr>
						<td align="left" style="font-family: 'Raleway', sans-serif; font-size:18px;  color:#4f0a4b; padding-left:15pt;"><b>Hi</b> <span style="color:#000;">${this.form.name}</span></td>
					</tr>
            <tr>
						<td height="35"></td>
					</tr>
					<tr>
						<td align="center" style="font-family: 'Raleway', sans-serif; font-size:22px; font-weight: bold; color:#4f0a4b;">Welcome to Caregiver Saathi</td>
					</tr>

					<tr>
						<td height="10"></td>
					</tr>


					<tr>
						<td align="center" style="font-family: 'Lato', sans-serif; font-size:14px; color:#000; line-height:24px; font-weight: 300;padding-left:15pt;padding-right:15pt;">
						Caregiver Saathi is an ecosystem of well-being for family caregivers taking care of their dear ones navigating chronic medical conditions, age related challenges or terminal illness. We are a one-stop platform offering programs, products and services that support the family caregivers through emotional aid, educational content, access to a community of experienced caregivers, support groups, counselling and professional service for home-based care.
						</td>
					</tr>

				</tbody></table>
			</td>
		</tr>
	
		<tr>
			<td align="center">
				<table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0" style="background-color:#FBF6F6;margin-left:20px; margin-right:20px;">
					<tbody><tr>
						<td height="35"></td>
					</tr>

        
         
					<tr>
						<td align="center" style="font-family: 'Raleway', sans-serif; font-size:22px; font-weight: bold; color:#4f0a4b;">Details</td>
					</tr>

           		<tr>
						<td height="10"></td>
					</tr> 			<tr>
						<td align="center" style="font-family: 'Raleway', sans-serif; font-size:20px; font-weight: bold; color:#4f0a4b;">Licence:<span style="color:#000;font-weight:300;">${this.form.licenceno}</span> </td>
					</tr>
            
            
               		<tr>
						<td height="20"></td>
					</tr> 			<tr>
						<td align="center" style="font-family: 'Raleway', sans-serif; font-size:16px;  color:#4f0a4b;"><b>Start Date: </b><span style="color:#000;"> ${this.time1} </span></td>
					</tr>
            
                      		<tr>
						<td height="10"></td>
					</tr> 			<tr>
						<td align="center" style="font-family: 'Raleway', sans-serif; font-size:16px;  color:#4f0a4b;"><b>End Date: </b> <span style="color:#000;"> ${this.time2}</span> </td>
					</tr>
            
            
            
					<tr>
						<td height="10"></td>
					</tr>


			

				</tbody></table>
			</td>
		</tr>

      		<tr>
			<td align="center">
				<table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0" style="background-color:#FBF6F6;margin-left:20px; margin-right:20px; ">
					<tbody><tr>
						<td height="30"></td>
					</tr>

        
         
					<tr>
						<td align="center" style="font-family: 'Lato', sans-serif; font-size:14px; color:#333; line-height:24px; font-weight: 300;padding-left:15pt;padding-right:15pt;">Please find below your login details to begin your journey with us. 
 </td>
					</tr>

           
            
               		<tr>
						<td height="20"></td>
					</tr> 			<tr>
						<td align="center" style="font-family: 'Raleway', sans-serif; font-size:16px;font-weight:bold;  color:#4f0a4b;">Username: <span style="color:#000;font-weight:300;"> ${this.form.email} </span> </td>
					</tr>
            
                      		<tr>
						<td height="10"></td>
					</tr> 			<tr>
						<td align="center" style="font-family: 'Raleway', sans-serif; font-size:16px; font-weight:bold;   color:#4f0a4b;">

Password:  <span style="color:#000; font-weight:300;"> caregiver@123 </span></td>
					</tr>
            
            
            

			

				</tbody></table>
			</td>
		</tr>
         	<tr>
			<td align="center">
				<table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0" style="background-color:#FBF6F6;margin-left:20px; margin-right:20px;">
					<tbody><tr>
						<td height="30"></td>
					</tr>

        
         
					<tr>
						<td align="center" style="font-family: 'Lato', sans-serif; font-size:14px; color:#000; line-height:24px; font-weight: 300;padding-left:15pt;padding-right:15pt;">If at any point you have queries regarding your joining, feel free to reach out to us at
 </td>
					</tr>

           
            
               		<tr>
						<td height="10"></td>
					</tr> 			<tr>
						<td align="center" style="font-family: 'Raleway', sans-serif; font-size:14px;text-decoration:underline;"><a href="#" target="_blank">info@caregiversaathi.co.in</a> </td>
					</tr>
            
           
            
            
            
					<tr>
						<td height="30"></td>
					</tr>


			

				</tbody></table>
			</td>
		</tr>
      	<tr>
			<td align="center">
				<table class="col-600" width="600" border="0" align="center" cellpadding="0" cellspacing="0" style="background-color:#FBF6F6; margin-left:20px; margin-right:20px; ">
					<tbody>
					<tr>
						<td align="center" style="font-family: 'Lato', sans-serif; font-size:16px;font-weight:bold; color:#4f0a4b; line-height:24px;padding-left:15pt;padding-right:15pt;" 
>
Team Caregiver Saathi 
 </td>
					</tr>
<tr>
						<td height="10"></td>
					</tr>
             			<tr>
						<td align="center" style="font-family: 'Raleway', sans-serif; font-size:14px;text-decoration:underline;"><a href="#" target="_blank">info@caregiversaathi.co.in</a> </td>
					</tr> 
					<tr>
						<td height="30"></td>
					</tr>
				</tbody></table>
			</td>
		</tr>
	
	<tr>
			<td align="center">
				<table align="center" class="col-600" width="600" border="0" cellspacing="0" cellpadding="0" style="background-color:#80d1d9; padding-bottom:10pt;">
					<tbody>	<tr>
						<td height="30"></td>
					</tr>
											<tr>
						<td align="center" style="font-family: 'Lato', sans-serif; font-size:20px;font-weight:bold; color:#4f0a4b; line-height:24px;padding-left:15pt;padding-right:15pt;" 
>
Follow us on our social media channels
 </td>
					</tr>
					<tr>
						<td height="25"></td>
					</tr>
					<tr>
						<td align="center">
				<table align="center"border="0" cellspacing="0" cellpadding="0">
								<tbody><tr>
								

									<td align="center" style="padding-right:15pt;">
										 <a href="https://www.facebook.com/caregiversaathi" target="_blank"> <img src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/facebook.png" width="25" height="25" /> </a>
									</td>

	                            	<td align="center" style="padding-right:15pt;">
										 <a href="https://www.twitter.com/BhavanaIssar/" target="_blank"> <img src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/twitter.png"  width="25" height="25" /> </a>
									</td>

                                    	<td align="center" style="padding-right:15pt;">
										 <a href="http://www.caregiversaathi.co.in/" target="_blank"> <img src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/share.png" width="25" height="25" /> </a>
									</td>

                                    	<td align="center" style="padding-right:15pt;">
										 <a href="https://linkedin.com/company/caregiver-saathi/" target="_blank"> <img src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/linkedin.png" width="25" height="25" /> </a>
									</td>
                                       	<td align="center" style="padding-right:15pt;">
										 <a href="https://www.instagram.com/caregiversaathi/" target="_blank"> <img src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/instagram.png" width="25" height="25" /> </a>
									</td>

									<td align="center">
											<a href="https://www.instagram.com/caregiversaathi/" target="_blank"> <img src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/image/youtube.png" width="25" height="25" /> </a>
									</td>
								</tr>
                  
                    
					<tr>
						<td height="20"></td>
					</tr>
								</tbody></table>



							</td></tr></tbody></table>
						</td>
					</tr>
				</tbody></table>
			</td>
		</tr>
				</tbody></table>
        </body>
       
        </html>

      `;
          await this.sendEmail(to, subject, body, [], bcc);
        }
        loader.close();
      } catch (err) {
        loader.close();
        this.$swal.fire({
          title: "Error",
          text: err.response.status === 409 ? err.response.data.message : "",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
      }
    },

    showCorporatebooking() {
      this.$router.push({ name: "admin-corporateBooking" });
    },

    onReset(event) {
      event.preventDefault();
      this.form.name = "";
      this.form.email = "";
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  components: {
    DatePicker,
  },
  computed: {
    ...mapState("corporate", ["get_AllBooking"]),
  },
};
</script>

<style>
.mx-calendar-content .cell:hover {
  color: white;
  background-color: #6c0b6b;
}
.mx-calendar-content .cell.active {
  color: white;
  background-color: #6c0b6b;
}
.back-btn {
  border: 1px solid black;
  padding: 4px 19px;
}
.border-box {
  border: 1px solid #ddd;
}
.fsize20px {
  font-size: 20px;
}
.w-48 {
  width: 48%;
}
.input-b {
  width: 100%;
  padding: 7px 2px 10px 4px;
}
form-btn .mt-3rem {
  margin-top: 3rem;
}
.justify-evenly {
  justify-content: space-evenly;
}
.mx-datepicker {
  width: 100% !important;
}
.cust-label-space label {
  margin-bottom: 3px !important;
}
</style>
